import { Button, type ButtonProps } from '@mui/material';
import Spinner from './Spinner';

interface SpinnerButtonProps extends ButtonProps {
  loading?: boolean;
}

export default function SpinnerButton({ loading, disabled, children, ...props }: SpinnerButtonProps) {
  return (
    <Button {...props} disabled={disabled || loading}>
      {loading ? <Spinner size="sm" /> : children}
    </Button>
  );
}
